import { MessageCircle } from "lucide-react";
import { useSiteConfig } from "@/hooks/useSiteConfig";

const WhatsAppFloat = () => {
  const { siteConfig } = useSiteConfig();
  const raw = siteConfig?.whatsapp_number || siteConfig?.phone;
  if (!raw) return null;

  const digits = raw.replace(/[^\d]/g, "");
  if (!digits) return null;

  const message = encodeURIComponent(
    "Hi! I would like more information about your buggy and ATV tours in Punta Cana."
  );

  return (
    <a
      href={`https://wa.me/${digits}?text=${message}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with us on WhatsApp"
      className="fixed bottom-5 right-5 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] shadow-xl transition-transform hover:scale-105 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
    >
      <MessageCircle className="h-7 w-7 text-white" aria-hidden="true" />
    </a>
  );
};

export default WhatsAppFloat;
